import modules from './modules';
import bgVideo from './bg-video';
import navigation from './navigation';
import fontawesome from './fontawesome';

/**
 * @function init
 * @description Kick off this modules functions
 */

const init = () => {
	modules();
	bgVideo();
	navigation();
	fontawesome();
};

export default init;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/index.js